export const defaultMapStyle: React.CSSProperties = {height: '400px', display: 'flex', flexDirection: 'column-reverse'};
